import axios from "axios";
import Vue from "vue";
import router from "@/router";
import { getHeader } from "../utils/header.js";
// 接口url前缀
const baseURL = "/jeecg-boot/";
// 预览url前缀
const pieviewURL = baseURL + "linxuan/";
// const timeout = 1000 * 10;
const service = axios.create({
  baseURL,
  // timeout,
});
service.interceptors.request.use(
  (config) => {
    let url = config.url.replace(config.baseURL, "");
    let code = config.code;
    config.headers = getHeader(url, code);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
service.interceptors.response.use(
  (response) => {
    const code = response.status;
    if (code === 200) {
      return response.data;
    } else {
      return Promise.reject(response);
    }
  },
  (error) => {
    // 主动取消不弹全局提示，由业务自行处理
    if (axios.isCancel(error)) {
      return Promise.reject(error);
    }
    const errCode =
      error &&
      error.response &&
      error.response.data &&
      error.response.data.code;
    switch (errCode) {
      case 401:
        Vue.prototype.$message.error("登录超时");
        window.sessionStorage.clear();
        setTimeout(() => {
          window.location.reload();
          window.close();
          router.replace({
            name: "Home",
            query: { redirect: router.currentRoute.fullPath },
          });
        }, 1000);
        break;
      case 500:
        Vue.prototype.$message.error(
          (error.response.data && error.response.data.message) ||
            "服务器异常,请稍后"
        );
        break;
      default:
        // 超时由业务页提示更明确文案，避免重复 toast
        if (
          !error.response &&
          error.code !== "ECONNABORTED" &&
          !(error.message || "").toLowerCase().includes("timeout")
        ) {
          Vue.prototype.$message.error("网络异常或服务无响应，请稍后重试");
        }
        break;
    }
    return Promise.reject(error);
  }
);
export { service, baseURL, pieviewURL };
